/* ==============================================================================
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
============================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

// @mui material components
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import Footer from 'examples/Footer';
import Navbar from 'examples/Navbars/NavBar';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import * as Func from 'services/Function';

// Component
import RpSaleCost from './RpSaleCost';
import RpRemain from './RpRemain';
import RPSaleAnalysis from './RpSaleAnalysis';
import RpPurchaseHistory from './RpPurchaseHistory';
import RpBranchBalance from './RpBranchBalance';
import RpSaleCostBranchABC from './RpSaleCostBranchABC';
import RpSaleCountry from './RpSaleCountry';
import RpCashierPerformance from './RpCashierPerformance';
import RpProductKey from './RpProductKey';
import RpProductQuery from './ReportProductQuery';
import RpSaleCostBranchABCByCat from './RpSaleCostBranchABCByCat';
import RpProfitRankingCat from './RpProfitRankingCat';
import RpMarketingCampaign from './RpMarketingCampaign';
import RpCashierPerformanceHour from './RpCashierPerformanceHour';
import RpDOH from './RpDOH';

function ReportPowerBi() {
  const mod = 'report_power_bi';
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const app = useSelector((state) => state[APP_STATE]);
  const [menu, setMenu] = useState([]);

  const init = () => {
    FetchData('OPTIONS', `/report/load`, app.token, {
      lang: app.lang,
      code: 'power_bi',
    }).then((result) => {
      if (result.status === 'ok') {
        setMenu(result.data);
      } else {
        Func.exitApp();
      }
    });
  };

  const setBtnBadge = (name, link, key) => {
    return (
      <Grid item xs={12} key={key}>
        <MDButton color='light' href={link} fullWidth>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'left',
              width: '100%',
              gap: 1,
              fontSize: 15,
              fontWeight: 400,
            }}
          >
            {key}. {name}
          </Box>
        </MDButton>
      </Grid>
    );
  };

  const renderButton = () => {
    return (
      <MDBox mb={7}>
        <Card sx={{ p: 2 }}>
          <Grid container spacing={1}>
            {menu.map((item, i) =>
              setBtnBadge(t(`menu.${item.code}`), `/${mod}/${item.code}`, i + 1)
            )}
          </Grid>
        </Card>
      </MDBox>
    );
  };

  const renderReport = () => {
    if (id === 'rp_sale_cost') return <RpSaleCost />;
    if (id === 'rp_remain') return <RpRemain />;
    if (id === 'rp_sale_analysis') return <RPSaleAnalysis />;
    if (id === 'rp_purchase_history') return <RpPurchaseHistory />;
    if (id === 'rp_branch_balance') return <RpBranchBalance />;
    if (id === 'rp_sale_cost_branch_abc') return <RpSaleCostBranchABC />;
    if (id === 'rp_sale_country') return <RpSaleCountry />;
    if (id === 'rp_cashier_performance') return <RpCashierPerformance />;
    if (id === 'rp_cashier_performance_hour') return <RpCashierPerformanceHour />;
    if (id === 'rp_product_key') return <RpProductKey />;
    if (id === 'rp_product_query') return <RpProductQuery />;
    if (id === 'rp_sale_cost_branch_abc_cat') return <RpSaleCostBranchABCByCat />;
    if (id === 'rp_profit_ranking_cat') return <RpProfitRankingCat />;
    if (id === 'rp_marketing_campaign') return <RpMarketingCampaign />;
    if (id === 'rp_doh') return <RpDOH />;

    return (
      <MDBox>
        <Navbar route={[t(`menu.report`), t(`menu.report_power_bi`)]} />
        <MDBox py={3}>{renderButton()}</MDBox>
      </MDBox>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    if (id === undefined) {
      init();
    }
  }, [id]);

  return (
    <DashboardLayout>
      {renderReport()}
      <Footer />
    </DashboardLayout>
  );
}

export default ReportPowerBi;
